import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

const popupFooter = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 14px 20px;
  border-top: 1px solid ${colors.gray.light};

  > button {
    height: 30px;
  }
`;

export default { popupFooter };
